/* LA_MINICART_RX_V2 */
/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  var __es_cart_url = '/cart.js';
  try { __es_cart_url += (__es_cart_url.indexOf('?') === -1 ? '?' : '&') + 'ts=' + Date.now(); } catch (e) {}
  jQuery.getJSON(__es_cart_url, function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

/*============================================================================
  LensAdvisor bundle safety + property cleanup (mini cart)

  - Filters internal LensAdvisor line-item properties (keys like _bundleId,
    _productType, _unique_identifier, _base_variant_id, etc.) so the Ajax cart
    drawer doesn't display debug/garbage text.
  - If a LensAdvisor bundle has no frame item (e.g., user removed the frame
    from the drawer), automatically removes remaining bundle items (lenses/
    add-ons) by line-item key to prevent orphaned items.
==============================================================================*/

ShopifyAPI.changeItemByKey = function(key, quantity, callback) {
  if (!key) {
    if (typeof callback === 'function') callback(null);
    return;
  }
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&id=' + encodeURIComponent(key),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

function laIsBundled(cartItem) {
  return !!(cartItem && cartItem.properties && cartItem.properties._bundleId);
}

function laIsFrame(cartItem) {
  return !!(cartItem && cartItem.properties && cartItem.properties._productType === 'frame');
}

function laFilterProperties(properties) {
  if (!properties) return null;
  var clean = {};
  var hideKeyExact = {
    'bundleId': true,
    '_bundleId': true,
    '_productType': true,
    'productType': true,
    '_unique_identifier': true,
    'unique_identifier': true,
    '_base_variant_id': true,
    'base_variant_id': true,
    '_lens_variant_ids': true,
    '_apply_discount': true,
    '_addOns': true,
    '_addons': true,
    '_parent': true,
    '_child': true
  };

  for (var k in properties) {
    if (!properties.hasOwnProperty(k)) continue;
    var v = properties[k];
    if (v === null || v === undefined || v === '') continue;
    if (hideKeyExact[k]) continue;

    var lk = (k || '').toString().toLowerCase();
    // Hide LensAdvisor internal / debug keys but KEEP user-facing data
    // (Lens Advisor may prefix user fields with '_' which we still want to show).
    if (lk.indexOf('bundle') !== -1 && lk.indexOf('id') !== -1) continue;
    if (lk.indexOf('unique') !== -1 || lk.indexOf('identifier') !== -1) continue;
    if (lk.indexOf('base_variant') !== -1) continue;
    if (lk.indexOf('producttype') !== -1) continue;
    if (lk.indexOf('lens_variant') !== -1) continue;
    if (lk.indexOf('lensadvisor') !== -1 || lk.indexOf('lensadvizor') !== -1) continue;

    // Remove leading underscores from display labels.
    var dk = (k || '').toString().replace(/^_+/, '');
    if (!dk) continue;

    clean[dk] = v;
  }
  return Object.keys(clean).length ? clean : null;
}

function laExtractRxProperties(properties) {
  // Extract user-facing RX/lens details for display in the mini-cart.
  // We intentionally keep these even if LensAdvisor prefixes keys with '_'.
  if (!properties) return null;

  var found = {};
  var denyRe = /(bundle|unique|identifier|base_variant|producttype|lens_variant|apply_discount|addons?|parent|child|lensadvisor|lensadvizor)/i;

  for (var k in properties) {
    if (!properties.hasOwnProperty(k)) continue;
    var v = properties[k];
    if (v === null || v === undefined || v === '') continue;

    var dk = (k || '').toString().replace(/^_+/, '').trim();
    if (!dk) continue;

    var lk = dk.toLowerCase();
    if (denyRe.test(lk)) continue;

    // Allowlist patterns for RX details
    var allow =
      lk.indexOf('lens group') !== -1 ||
      lk.indexOf('prescription type') !== -1 ||
      lk.indexOf('prescription method') !== -1 ||
      lk === 'frame' || lk.indexOf('frame:') === 0 ||
      lk.indexOf('od') === 0 || lk.indexOf('os') === 0 ||
      lk.indexOf('pd') === 0 || lk.indexOf('pupillary') !== -1 ||
      lk.indexOf('sphere') !== -1 || lk.indexOf('sph') !== -1 ||
      lk.indexOf('cyl') !== -1 || lk.indexOf('axis') !== -1 ||
      lk.indexOf('add') !== -1 || lk.indexOf('prism') !== -1 ||
      lk.indexOf('seg') !== -1 || lk.indexOf('height') !== -1;

    if (!allow) continue;

    // Normalize some labels
    dk = dk.replace(/\s*\|\s*/g, ' | ');
    found[dk] = v;
  }

  // Rebuild in a nice, predictable order (if present)
  var orderedKeys = [
    'Lens Group',
    'Prescription Type',
    'Prescription Method',
    'Frame',
    'OD Right',
    'OS Left',
    'PD'
  ];

  var ordered = {};
  orderedKeys.forEach(function(key) {
    if (found[key] !== undefined) ordered[key] = found[key];
  });

  Object.keys(found).forEach(function(k) {
    if (ordered[k] === undefined) ordered[k] = found[k];
  });

  return Object.keys(ordered).length ? ordered : null;
}


function laEnforceBundles(cart, done) {
  try {
    if (!cart || !cart.items || !cart.items.length) {
      done(cart);
      return;
    }

    var groups = {};
    cart.items.forEach(function(it) {
      if (!laIsBundled(it)) return;
      var bid = it.properties._bundleId;
      if (!bid) return;
      if (!groups[bid]) groups[bid] = { items: [], hasFrame: false };
      groups[bid].items.push(it);
      if (laIsFrame(it)) groups[bid].hasFrame = true;
    });

    var orphanKeys = [];
    Object.keys(groups).forEach(function(bid) {
      var g = groups[bid];
      if (!g.hasFrame) {
        g.items.forEach(function(it) {
          if (it && it.key) orphanKeys.push(it.key);
        });
      }
    });

    if (!orphanKeys.length) {
      done(cart);
      return;
    }

    var i = 0;
    (function next() {
      if (i >= orphanKeys.length) {
        ShopifyAPI.getCart(done);
        return;
      }
      ShopifyAPI.changeItemByKey(orphanKeys[i], 0, function() {
        i += 1;
        next();
      });
    })();
  } catch (e) {
    done(cart);
  }
}

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : '.enj-add-to-cart-btn',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  // Fix grammar in PDP add-to-cart popup: "There is 1 item" vs "There are N items"
  // IMPORTANT: never rely on the presence of .product-item-count in the target <p>,
  // because earlier updates (e.g., empty-cart message) may remove that span.
  var updateAddToCartPopupCountLine = function(count) {
    try {
      var $popup = $('.product-popup');
      if (!$popup.length) return;

      // In template-popup-ajax-addtocart.liquid this is always the FIRST <p> inside .more_info
      var $p = $popup.find('.more_info p').first();
      if (!$p.length) return;

      // Prefer the passed count, but fall back to whatever is already in the DOM.
      var n = parseInt(count, 10);
      if (isNaN(n)) {
        var domN = parseInt($popup.find('.product-item-count').first().text(), 10);
        if (!isNaN(domN)) n = domN;
      }
      if (isNaN(n)) n = 0;

      if (n === 1) {
        $p.html('There is <span class="product-item-count">1</span> item<br>in your cart');
      } else {
        $p.html('There are <span class="product-item-count">' + n + '</span> items<br>in your cart');
      }
    } catch (e) {}
  };


  updateCountPrice = function (cart) {
    // ES: keep header cart dot stable (prevents flicker on navigation)
    try {
      var esHasItems = cart && cart.item_count > 0;
      $('.js-number-cart').toggleClass('active', esHasItems);
      document.documentElement.classList.toggle('es-cart-has-items', esHasItems);
      if (window.localStorage) localStorage.setItem('es_cart_has_items', esHasItems ? '1' : '0');
    } catch (e) {}

    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      $('.product-popup').find('.product-item-count').html(cart.item_count);
      updateAddToCartPopupCountLine(cart.item_count);
      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();
      var $addToCart_btn = $(this).find(settings.addToCartSelector);
      // Add class to be styled if desired
      $addToCart_btn.removeClass('is-added').addClass('is-adding');
      $addToCart_btn.find("i").replaceWith('<i class="enj-loader-add-to-cart fsz-unset"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></i>');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product, form) {
    var $addToCart_btn = $(form).find(settings.addToCartSelector);
    $addToCart_btn.removeClass('is-adding').addClass('is-added');
    $addToCart_btn.find('.enj-loader-add-to-cart').html('<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" height="400" width="400" xml:space="preserve" id="svg2" version="1.1"><metadata id="metadata8"><rdf:RDF><cc:Work rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/></cc:Work></rdf:RDF></metadata><defs id="defs6"/><g transform="matrix(1.3333333,0,0,-1.3333333,0,400)" id="g10"><g transform="scale(0.1)" id="g12"><path id="path14" style="/* fill:#231f20; */fill-opacity:1;fill-rule:nonzero;stroke:none;" d="M 2539.18,1385.02 C 2479.15,849.23 2004.9,434.289 1446.39,470.129 931.406,503.16 516.711,917.871 483.672,1432.85 c -38.359,597.88 439.844,1099.19 1029.878,1099.19 78.39,0 149.09,-7.24 218.27,-21.98 42.37,-9.03 86.4,4.1 116.99,34.78 v 0 c 71.82,72.04 34.9,194.92 -64.67,215.74 -88.86,18.58 -179.73,29.87 -270.59,29.87 -709.417,0 -1290.445,-581.02 -1290.445,-1290.45 0,-709.418 581.028,-1290.449 1290.445,-1290.449 661.24,0 1210.92,504.781 1282.54,1147.799 8.47,76.02 -50.73,142.65 -127.21,142.65 h -2.45 c -65.64,0 -119.94,-49.75 -127.25,-114.98 z M 894.004,1654.48 v 0 c -49.668,-49.89 -49.578,-130.58 0.207,-180.36 L 1384.35,983.98 2584.51,2184.15 c 49.87,49.87 49.87,130.71 0,180.57 l -0.23,0.23 c -49.88,49.87 -130.74,49.85 -180.6,-0.03 L 1384.35,1344.99 1074.79,1654.67 c -49.94,49.95 -130.95,49.87 -180.786,-0.19"/></g></g></svg>');

    $('.product-popup').find('.product-name').html(product.title);  
    $('.product-popup').find('.product-price').html(Shopify.formatMoney(product.price, settings.moneyFormat)); 
    $('.product-popup').find('.product-qty').html(product.quantity,); 
                                                  $('.product-popup').find('.product-total').html(Shopify.formatMoney(product.line_price, settings.moneyFormat)); 


    $('.product-popup').find('.product-image img').attr('src', product.image);

    // =====================================================
    // Eyeshells UX (BEST):
    // On PDP (template-product), open the right-side mini cart drawer
    // instead of showing the add-to-cart success popup.
    // This avoids the distracting "fly to corner" close animation and
    // keeps the shopping flow smooth.
    // =====================================================
    try {
      var isPDP = $body && $body.hasClass('template-product');

      if (isPDP) {
        // Ensure popup is not shown on PDP
        $('.product-popup').removeClass('active');

        // Open minicart drawer (same behavior as clicking cart icon)
        $('.js-minicart').addClass('active');
        $('.bg-minicart').addClass('active');
        $('body').addClass('es-minicart-open');
      } else {
        showPopup('.product-popup');
      }
    } catch (e) {
      // Fallback to original behavior
      showPopup('.product-popup');
    }

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');
    $addToCart.find('.enj-loader-add-to-cart').remove();

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Enforce LensAdvisor bundles first (remove orphan lens/add-on items)
    laEnforceBundles(cart, function(updatedCart) {
      // Update quantity and price
      updateCountPrice(updatedCart);
      buildCart(updatedCart);
    });
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
            // ES: Consistent empty-state (match snippets/minicart.liquid)
            var emptyText = (settings && settings.emptyText) ? settings.emptyText : "Your shopping cart is empty";
            var shopNowText = (settings && settings.shopNowText) ? settings.shopNowText : "START SHOPPING";
            var shopNowUrl = (settings && settings.shopNowUrl) ? settings.shopNowUrl : "/";
            $cartContainer.append(
              '<div class="list_product_minicart empty">' +
                '<div class="empty-product_minicart">' +
                  '<p class="mb-0">' + emptyText + '</p>' +
                  '<a href="' + shopNowUrl + '" class="to-cart">' + shopNowText + '</a>' +
                '</div>' +
              '</div>'
            );
      cartCallback(cart);
      // ES: keep header cart dot in sync for empty state
      try {
        $('.js-number-cart').removeClass('active');
        document.documentElement.classList.remove('es-cart-has-items');
        if (window.localStorage) localStorage.setItem('es_cart_has_items', '0');
      } catch (e) {}
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      

// LensAdvisor: keep user-facing RX info, and remove duplicates from generic properties
var rxProps = laExtractRxProperties(cartItem.properties);
var cleanProps = laFilterProperties(cartItem.properties);
if (rxProps && cleanProps) {
  try {
    Object.keys(rxProps).forEach(function(k){ delete cleanProps[k]; });
    if (!Object.keys(cleanProps).length) cleanProps = null;
  } catch(e) {}
}

      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cleanProps,
        rx: rxProps,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        vendor: cartItem.vendor
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat)
    }
    $('.product-popup').find('.product-total-cart').html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));

    $cartContainer.append(template(data));

    cartCallback(cart);
    $('.js-number-cart').addClass('active');
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // IMPORTANT: ajaxCart.init() is called multiple times in this theme (filters/load more).
    // Prevent duplicate handlers by using namespaced events and clearing old ones first.
    $body.off('click.ajaxCartQtyAdjust', '.ajaxcart__qty-adjust');
    $body.off('click.ajaxCartRemove', '.remove-product, [data-minicart-remove]');
    $body.off('submit.ajaxCart', 'form.ajaxcart');
    $body.off('focus.ajaxCart', '.ajaxcart__qty-adjust');
    $body.off('change.ajaxCart', 'textarea[name="note"]');

    // Add or remove from the quantity
    $body.on('click.ajaxCartQtyAdjust', '.ajaxcart__qty-adjust', function(e) {
      e.preventDefault();
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Remove a line item from the cart (minicart remove "X")
    $body.on('click.ajaxCartRemove', '.remove-product, [data-minicart-remove]', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var $el = $(this);
      var line = parseInt($el.data('line'), 10);
      if (!line || isNaN(line)) return;
      updateQuantity(line, 0);
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit.ajaxCart', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus.ajaxCart', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change.ajaxCart', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      // Use cartUpdateCallback so LensAdvisor bundle enforcement runs too
      ShopifyAPI.getCart(cartUpdateCallback);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
          // ES: removed debug log
          updatePricingQty(qty);
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
          updatePricingQty(qty);
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));